export default __webpack_public_path__ + "static/media/mcb-logo.888a6fcf.svg";